import { Autocomplete, InputAdornment, TextField } from "@mui/material";
import { Box, Grid } from "@mui/system";
import SearchIcon from "@mui/icons-material/Search";
import BrandConfigReportTableFilterItems from "./BrandConfigReportTableFilterItems";
import { useSelector } from "react-redux";
import { useEffect, useMemo } from "react";
import { setSelectedBrandName } from "../../../../../features/brandConfigurationReportSlice";
import { useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";

const BrandConfigReportTableFilterCard = () => {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();

  const {
    brandConfigurationReportList: modifiedbrandConfiguration,
    selectedBrandName,
  } = useSelector((state: any) => state.brandConfigurationReport);

  const clearSelectedBrandName = () => {
    // Dispatch action to clear selected brand name
    dispatch(setSelectedBrandName(""));
  };

  //-- Extract unique brand names for Autocomplete filter
  const brandNames = useMemo(() => {
    const set = new Set<string>();
    (modifiedbrandConfiguration || []).forEach((r: any) => {
      if (typeof r?.brand === "string") set.add(r.brand.trim());
    });
    return Array.from(set);
  }, [modifiedbrandConfiguration]);

  //-- this hold search params in url
  useEffect(() => {
    // Update selectedTemplate when searchParams change (e.g., on back/forward navigation)
    dispatch(setSelectedBrandName(searchParams.get("search")));
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Box sx={{ padding: "0px 16px 10px 16px !important" }}>
        <Grid container rowSpacing={6} columnSpacing={3} alignItems={"center"}>
          <Grid size={3}>
            <Autocomplete
              fullWidth
              disablePortal
              freeSolo
              data-tracker="620"
              sx={{ width: "100%" }}
              options={brandNames}
              value={selectedBrandName || ""}
              disableClearable={!selectedBrandName} // Hide clear icon when empty
              onChange={(_, newValue: string | null) => {
                dispatch(setSelectedBrandName(newValue ?? ""));
                setSearchParams((prevParams) => {
                  const updatedParams = Object.fromEntries(prevParams);
                  if (newValue) {
                    updatedParams.search = newValue;
                    updatedParams.page = "0";
                  } else {
                    delete updatedParams.search;
                  }
                  return updatedParams;
                });
              }}
              getOptionLabel={(opt) => opt || ""}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Brand Name"
                  InputProps={{
                    ...params.InputProps,
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon sx={{ marginLeft: "12px" }} />
                      </InputAdornment>
                    ),
                  }}
                  color="secondary"
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault(); // Prevent default form submission
                      const inputValue = (
                        e.target as HTMLInputElement
                      ).value.trim();

                      if (inputValue) {
                        // Dispatch the search term
                        dispatch(setSelectedBrandName(inputValue));

                        // Update URL params
                        setSearchParams((prevParams) => {
                          const updatedParams = Object.fromEntries(prevParams);
                          updatedParams.search = inputValue;
                          updatedParams.page = "0";
                          return updatedParams;
                        });

                        // Close the dropdown by blurring the input
                        (e.target as HTMLInputElement).blur();
                      }
                    }
                  }}
                />
              )}
              size="small"
            />
          </Grid>
          <Grid size={7}>
            <BrandConfigReportTableFilterItems
              clearSelectedBrandName={clearSelectedBrandName}
            />
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default BrandConfigReportTableFilterCard;
